import { Inject, Injectable } from '../../injection';
import { IMobizHttpService } from '../interfaces/mobiz-http.interface';
import { IAuthTokenService } from './auth-token.interface';
import { IMobizContextService } from './mobiz-context.interface';
import { IMobizStateService } from './mobiz-state.interface';
import { IMobizStorageService } from './mobiz-storage.interface';
import { IUserService } from './user.interface';

@Injectable()
export class MobizContextService implements IMobizContextService {
  constructor(
    @Inject(IMobizStorageService)
    public storage: IMobizStorageService,
    @Inject(IMobizHttpService)
    public http: IMobizHttpService,
    @Inject(IAuthTokenService)
    public token: IAuthTokenService,
    @Inject(IMobizStateService)
    public state: IMobizStateService,
    // The api services should not be exposed as public
    @Inject(IUserService)
    public userService: IUserService,
  ) {
  }

}
